/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { getDocumentsHistory } from '@/services/getDocumentsHistory';
import { removeHyphensAndSlashes } from '@/utils/removeHyphensAndSlashes';
import { DocumentsHistoryListInfo, TableFilters } from './types';
import DocumentsHistoryTable from './components/DocumentsHistoryTable/DocumentsHistoryTable';

const today = new Date();
const oneDayAgo = new Date(today);
oneDayAgo.setDate(today.getDate() - 1);

const initialFilters: TableFilters = {
  fechaDesde: oneDayAgo,
  fechaHasta: today,
};

const DocumentsHistory = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [parsedData, setParsedData] = useState<DocumentsHistoryListInfo[]>([]);

  const {
    data: documents,
    mutate,
    isPending,
  } = useMutation({
    mutationKey: ['DocumentsHistory'],
    mutationFn: () => {
      const adjustedFilters = {
        ...filters,
        fechaHasta: filters.fechaHasta
          ? new Date(filters.fechaHasta.getTime() + 24 * 60 * 60 * 1000)
          : null,
      };
      return getDocumentsHistory(adjustedFilters);
    },
  });

  useEffect(() => {
    if (documents) {
      const newData = documents.map((item: any) => {
        const { fecha, contenedor, viaje, liquidacionWeb, ...rest } = item;

        const fechaDocumentoParce = new Date(item?.fecha);

        return {
          ...rest,
          fecha: fechaDocumentoParce,
          nombreViaje: viaje?.nombre,
          contenedor: removeHyphensAndSlashes(contenedor),
          rutCliente: liquidacionWeb?.rutCliente,
        };
      });
      setParsedData(newData);
    }
  }, [documents]);

  useEffect(() => {
    mutate();
  }, [mutate]);

  return (
    <DocumentsHistoryTable
      filters={filters}
      data={parsedData || []}
      setFilters={setFilters}
      onSearch={mutate}
      isLoading={isPending}
    />
  );
};

export default DocumentsHistory;
